import commonMixin from '../../mixins/_common';
import modalMixin from './../../mixins/_modal';
import flashMessageMixin from '../../mixins/_flash_messages';

// モーダルを開く前のメッセージ
const OPEN_ALERT_MESSAGE = 'プロダクトカテゴリを変更すると、設定中のスペックは全てリセットされますが、宜しいですか？';

/**
 * リスト表示コンポーネント
 */
const productCategoryList = {
    name: 'productCategoryList',
    template: '#product_category_list_template',
    data () {
        return {
            // 選択中のカテゴリデータ
            selected_category: {},
            // プロダクトカテゴリリスト
            categories: [],
        };
    },
    props: {
        // 下位カテゴリが表示される指定ページキー
        category_code: {
            type: String,
            default: '0',
            require: false,
        }
    },
    computed: {
        // 下位カテゴリが選択されているか否か
        hasSelectedCategory: function () {
            return (Object.keys(this.selected_category).length > 0);
        },
        // 下位カテゴリが存在するカテゴリか否か
        isExistChildCategory: function () {
            if (this.hasSelectedCategory && !this.isFlagOn(this.selected_category.is_leaf)) {
                return true;
            }
            return false;
        },
        // 末端のカテゴリ一覧か否か(末端は一つのみ)
        isEndCategories: function () {
            if (this.categories.length === 1 && this.isFlagOn(this.categories[0].is_leaf)) {
                return true;
            }
            return false;
        }
    },
    mixins: [
        commonMixin,
        flashMessageMixin,
    ],
    watch: {
        // カテゴリコードが変更されたら取得しなおす
        category_code: {
            async handler() {
                await this.get();
                // 自動横スクロール
                this.$nextTick(function() {
                    this.scrollProdCateList();
                });
            },
            immediate: true,
        },
        // 下位カテゴリが選択されたら
        ['selected_category']: function () {
            if (this.hasSelectedCategory) {
                if (this.isExistChildCategory) {
                    this.emitProductCode('');
                    this.emitCreatePathName();
                } else {
                    this.emitProductCode(this.selected_category.category_code);
                }
            }
        },
        // 末端のカテゴリ一覧だった末端を選択したことにする
        isEndCategories: function (bool) {
            if (bool) {
                this.selectCategory(this.categories[0]);
            }
        }
    },
    emits: [
        'emit-create-path-name',
        'emit-product-code',
    ],
    methods: {
        // 対象のカテゴリコードが選択されているか
        isSelected: function (categoryCode) {
            if (this.hasSelectedCategory && this.selected_category.category_code === categoryCode) {
                return true;
            }
            return false;
        },
        // フラグが1ならtrue
        isFlagOn: function (flag) {
            return (Number(flag) === 1);
        },
        // 下位カテゴリを選択
        selectCategory: function (category) {
            this.selected_category = category;
        },
        // 指定カテゴリコードに紐づく下位カテゴリリストを取得
        get: async function () {
            if (this.category_code === null) {
                return;
            }
            // 初期化
            this.selected_category = {};
            this.categories = [];

            let message = this.exception_error_message;
            try {
                this.$_loading();
                const response = await axios.get('/item/get_product_category_list', {
                    params: {
                        category_code: this.category_code
                    }
                });
                if (response.data.status === 'OK') {
                    this.categories = response.data.data;
                    // エラーメッセージを空にする
                    message = '';
                } else {
                    message = response.data.message;
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            this.productCategorySelectorFlashMessage(message);
        },
        // モーダルのフラッシュメッセージに表示させる
        productCategorySelectorFlashMessage: function (message, target = null) {
            if (!target) {
                target = this;
            }
            if (typeof target.$parent.$refs.productCategorySelector === 'undefined') {
                this.productCategorySelectorFlashMessage(message, target.$parent);
                return;
            }

            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, target);
            }
        },
        // リストを横スクロールさせる
        scrollProdCateList: function () {
            let scroll = 0;
            const listGroups = $(this.$refs.prodCateListWrapper).closest('.prodCate-root-list-wrapper').find('.prodCate-list-group');
            const listCount = listGroups.length;
            listGroups.map(function (index) {
                if ((index + 1) < listCount) {
                    scroll = scroll + $(this).outerWidth();
                }
            });
            $(this.$refs.prodCateListWrapper).closest('.overflow-x-scroll').animate({
                scrollLeft: scroll
            }, 300, 'swing');
        },

        // -------------------------
        // emit
        // -------------------------

        // 選択中のカテゴリ名を親へ通知
        emitCreatePathName: function (pathNames = []) {
            pathNames.unshift(this.selected_category.category_name);
            this.$emit('emit-create-path-name', pathNames);
        },
        // 末端のプロダクトコードを親へ通知
        emitProductCode: function (productCode) {
            this.$emit('emit-product-code', productCode);
        },
    }
};

/**
 * プロダクトコード選択コンポーネント
 */
export default {
    name: 'productCategorySelector',
    template: '#product_category_selector_component_template',
    data () {
        return {
            // カテゴリパス名
            path_name: '',
            // プロダクトコード
            code: '',
        };
    },
    props: {
        // モーダルを開く前にアラート出すかフラグ
        open_alert: {
            type: Boolean,
            default: false,
        },
        // v-modelの値
        modelValue: {
            type: Object,
            default: {},
        }
    },
    components: {
        'product-category-list': productCategoryList,
    },
    computed: {
        // プロダクトコードが選択されているか
        hasCode: function () {
            return (this.code.length > 0);
        }
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin,
    ],
    emits: ['update:modelValue'],
    methods: {
        // モーダルを開く
        show: async function () {
            if (this.open_alert && !await swalConfirm(OPEN_ALERT_MESSAGE)) {
                return;
            }
            // ヤフーyahooAPI用アクセストークンが有効かチェック(トークンがリフレッシュされる)
            if (!await this.$root.$refs.yahooAuth.isValidToken()) {
                return;
            }
            this.path_name = '';
            this.code = '';
            this.open();
        },
        // パス名を構築
        createPathName: function (pathNames) {
            this.path_name = pathNames.join(' ＞ ');
        },
        // 選択されたプロダクトコードをセット
        setProductCode: function (code) {
            this.code = code;
        },
        // 設定データを更新
        save: function (event) {
            // バリデーションエラーの場合はそのままフォーム送信する
            if (!event?.target?.form?.checkValidity()) {
                return;
            }
            event.preventDefault();

            this.emitUpdateData();
            this.close();
        },

        // -------------------------
        // emit
        // -------------------------

        // 親へ通知
        emitUpdateData: function () {
            this.$emit('update:modelValue', {
                path_name: this.path_name,
                code: this.code,
            });
        }
    }
};
